import { render, staticRenderFns } from "./PriorityContactsView.vue?vue&type=template&id=18a47311&scoped=true&"
import script from "./PriorityContactsView.vue?vue&type=script&lang=js&"
export * from "./PriorityContactsView.vue?vue&type=script&lang=js&"
import style0 from "./PriorityContactsView.vue?vue&type=style&index=0&id=18a47311&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a47311",
  null
  
)

export default component.exports